// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { compactHeaderStyles } from "@steiner/Overrides/Pages/CompactHeader";
import { color, hideElement, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

compactHeaderStyles.page = {
    padding: 0, // * Padding doesn't work with fullWidth because of logic on Line 64 if Page component
    fullWidth: [true, true, true, true, true], // make the header full width and control the margins with container css
    css: css`
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: ${getProp("theme.zIndex.compactHeader")};
        opacity: 0;
        transform: translateY(-100%) translateX(0);
        background: ${color("primary")};
        padding: 4px 0;

        ${xScreen("lte", "md")} {
            ${hideElement}
        }
    `,
};

compactHeaderStyles.pageInnerWrapper = {
    css: css`
        grid-template-columns: 100px 1fr auto;
        gap: 32px;
    `,
};

compactHeaderStyles.mainNavigationWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: flex-start;
    `,
};

compactHeaderStyles.linkListWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 24px;
    `,
};
